import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProjectContextService } from '../services/project-context.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const token = sessionStorage.getItem('access_token');
  const projectId = inject(ProjectContextService).activeProjectId;

  const setHeaders: Record<string, string> = {};
  if (token) {
    setHeaders['Authorization'] = `Bearer ${token}`;
  }
  // Scope every request to the active project (chatbot). The API validates it against the tenant.
  if (projectId) {
    setHeaders['X-Project-Id'] = projectId;
  }

  if (Object.keys(setHeaders).length > 0) {
    req = req.clone({ setHeaders });
  }

  return next(req);
};
